import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { AccordionModule } from 'primeng/accordion';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CalendarModule } from 'primeng/calendar';
import { MiscModule } from 'projects/core/src/public-api';
import { DesktopProjectModule } from '../project/desktop-project.module';
import { CustomersListComponent } from './view/customers-list/customers-list.component';
import { CustomerMiscModule } from 'projects/app-misc/src/app/modules/customer/customer-misc.module';

import { CheckboxModule } from 'primeng/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { InputTextModule } from 'primeng/inputtext';
import { QbCustomerLinkDialogComponent } from './view/customers-list/qb-customer-link-dialog/qb-customer-link-dialog.component';
import { DropdownModule } from 'primeng/dropdown';
import { ListboxModule } from 'primeng/listbox';
import {RouterModule} from '@angular/router';

@NgModule({
    declarations: [
        CustomersListComponent,
        QbCustomerLinkDialogComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
    RouterModule,
        ReactiveFormsModule,
        TableModule,
        MatDialogModule,
        MatRippleModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        AccordionModule,
        SelectButtonModule,
        CalendarModule,
        MiscModule,
        InputTextModule,
        CustomerMiscModule,
        CheckboxModule,
        DesktopProjectModule,
        DropdownModule,
        ListboxModule
    ],
    entryComponents: [
        QbCustomerLinkDialogComponent
    ]
})
export class CustomerModule { }
